 
import { faUser, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import NSLogo from '../../images/Northspyre-Logo.png';

const getInitials = (name: string) => {
    const wordsToFilter = ['pm', 'admin', 'external', 'test', 'login', 'project', 'manager', 'data', 'all', 'leed', 'example'];
    const nameArr = name.trim().replace(/[^a-zA-Z ]/g, '').split(' ');
    const filteredNameArr = nameArr.filter((string: string) => string && !wordsToFilter.includes(string.toLocaleLowerCase()));
    let initials = '';
    if (filteredNameArr.length > 0) {
        const [firstWord] = filteredNameArr;
        const [firstLetter] = firstWord;
        initials = firstLetter;

        if (filteredNameArr.length > 1) {
            const lastWord = filteredNameArr[filteredNameArr.length - 1];
            const [lastLetter] = lastWord;
            initials += lastLetter;
        }
    }
    return initials.toUpperCase();
};

export interface IProps {
    size?: number,
    radius?: number,
    fontSize?: string,
    className?: string,
    userName?: string;
    userPicture?: string | null;
    isSquare?: boolean;
    textColor?: string;
    shouldUseNSLogo?: boolean;
    shouldUseIcon?: boolean;
    customIcon?: IconDefinition;
    backgroundColor?: string;
}

const NSUserAvatar = ({
    size = 30,
    radius = 15,
    fontSize = '1em',
    className,
    userName,
    userPicture,
    isSquare,
    textColor = 'white',
    shouldUseNSLogo = false,
    shouldUseIcon = false,
    customIcon,
    backgroundColor = 'var(--primary)',
}: IProps) => {
    const initials = userName ? getInitials(userName) : '';
    const userImage = userPicture?.includes('https') ? `${userPicture}` : `https://northspyre-images.s3.amazonaws.com/${userPicture}`;
    const userIconSvgPath = shouldUseIcon ? String(faUser.icon[4]) : '';

    return (
        <div className={className}>
            {(userPicture || shouldUseNSLogo) ? (

                <span className="account-user-avatar">
                    <img
                        src={shouldUseNSLogo ? NSLogo : userImage}
                        alt="user avatar"
                        className={isSquare ? 'rounded' : 'rounded-circle'}
                        height={size}
                        width={size}
                    />
                </span>
            ) : (
                <svg height={size} width={size} data-testid="empty-ns-avatar-svg">
                    <g>
                        {isSquare ? (
                            <rect
                                x="0"
                                y="0"
                                width="100%"
                                height="100%"
                                rx="5"
                                ry="5"
                                fill={backgroundColor}
                            />
                        )
                            : <circle cx="50%" cy="50%" r={radius} fill={backgroundColor} />}
                        {shouldUseIcon ? (
                            <svg
                                viewBox="0 0 448 512"
                                width="50%"
                                height="50%"
                                x="25%"
                                y="25%"
                            >
                                <path
                                    fill={textColor}
                                    d={customIcon ? String(customIcon.icon[4]) : userIconSvgPath}
                                />
                            </svg>
                        ) : (
                            <text
                                x="50%"
                                y="52%"
                                textAnchor="middle"
                                stroke={textColor}
                                fill={textColor}
                                fontSize={fontSize}
                                strokeWidth="1px"
                                dy=".3em"
                                letterSpacing="1"
                                fontWeight="lighter"
                            >
                                {initials}
                            </text>
                        )}
                    </g>
                </svg>
            )}
        </div>
    );
};

export default NSUserAvatar;
